<template>
    <div class="taskReportWrap">
        <div class="taskReportBox">
            <div class="taskReportLeft" :class="{'fullBox':reportFlag}">
                <div class="taskReportHeader">
                    <div class="AuditBoxTab">
                        <div class="AuditBoxTab_left">
                            <div class="AuditBoxTab_box" :class="{'active':auditTabInd==0}" @click="auditTabHandle(0)">{{$t('Lab document')}}</div>
                            <div class="AuditBoxTab_box" :class="{'active':auditTabInd==1}" @click="auditTabHandle(1)">{{$t('Lab Report')}}</div>
                            <div class="AuditBoxTab_box" :class="{'active':auditTabInd==2}" @click="auditTabHandle(2)" v-show="!isStudent">{{$t('Personal information')}}</div>
                        </div>
                        <div class="AuditBoxTab_right">
                            <el-button v-if="reportFlag" class="mainBtn" size="mini" @click="enterLearn">{{$t('Enter learning')}}</el-button>
                        </div>

                    </div>

                </div>
                <div class="taskReportContent">
                    <div class="taskReportContent_box tableCommonClass" v-show="auditTabInd==0" v-html="task.taskremark"></div>
                    <!-- <div class="taskReportContent_box tableCommonClass" v-show="auditTabInd==1" v-html="reportInfo.report"></div> -->
                    <div class="taskReportContent_box tableCommonClass" v-show="auditTabInd==1" >
                        <markdownShow :value="reportInfo.report"></markdownShow>
                    </div>
                    <div class="taskReportContent_box" v-show="auditTabInd==2">
                        <div class="messboxItem">
                            <div class="messboxItem_l">{{$t('Experiment name')}}：</div>
                            <div class="messboxItem_r">{{task.title}}</div>
                        </div>
                        <div class="messboxItem">
                            <div class="messboxItem_l">{{$t('Name')}}：</div>
                            <div class="messboxItem_r">{{user.uname}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="taskReportRight" v-show="!reportFlag">
                <div class="taskReportHeader">
                    <div class="taskReportHeader_inner">
                        <div class="taskReportHeader_l">{{$t('Review the results')}}</div>
                        <div class="taskReportHeader_r">
                            <el-button  v-if="reportInfo.status == 3"   class="mainBtn" size="mini" @click="enterLearn">{{$t('Continue to answer')}}</el-button>
                            <el-button v-if="reportInfo.status != 3" class="mainBtn" size="mini" @click="enterLearn">{{$t('Enter learning')}}</el-button>
                        </div>
                    </div>
                </div>
                <div class="taskReportContent">
                    <div class="auditReport">
                        <div class="auditReportBox" v-if="reportInfo.status!=3">
                            <span>{{$t('score')}}</span>
                            <span>{{reportInfo.score}}</span>
                        </div>
                        <div class="auditReportBox">
                            <span>{{$t('Teacher comments')}}</span>
                            <!-- <div class="remarkBox">{{reportInfo.comment}}</div> -->
                            <div class="remarkBox">
                                <markdownShow :value="reportInfo.comment"></markdownShow>
                            </div>
                        </div>
                        <div class="auditReportBox" v-if="reviewTags.length >0">
                            <span>{{$t('review')}}</span>
                            <div class="commentCheckbox">
                                <el-tag effect="plain" v-for="review in reviewTags" :key="review">{{review}}</el-tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { getAjax, postAjax } from '@/api/index.js';
import isMobile from '@/api/isMobile.js';
import Prism from "prismjs";
import $ from 'jquery';
import markdownShow from '@/components/markdown/markdownShow.vue';
export default{
    props:{
        reportFlag:{},
        spaceid:{},
        subid:{},
        sccid:{},
        cangodetail:{},
        isStudent:{
            type:[Boolean,String],
            default:false
        },

    },
    data(){
        return{
            reportInfo:{},
            task:{},
            user:{},
            reviewTags:[],
            auditTabInd:0,
        }
    },
    created() {
        this.getPost();
    },
    components:{markdownShow},
    methods: {
        getPost(){
            let URI = "/s/spaceStudy/getPost";
            let param = { spaceid: this.spaceid ,subid:this.subid ,sccid:this.sccid , getTask:true};
            postAjax(URI,param).then((res)=>{
                this.reportInfo =  res.data;
                this.task =  res.task;
                this.user =  res.user;
                if (this.reportInfo.comment == ''){
                    this.reportInfo.comment = this.reportInfo.status == 4 ? this.$t('Through') : "无评语"
                }
                if (typeof res.reviewTags != "undefined"){
                    this.reviewTags =  res.reviewTags;
                }
                setTimeout(()=>{
                    $('.taskReportLeft pre').removeClass().each(function () {
                        $(this).addClass("line-numbers");
                        var languageType =  $(this).find("code").attr("class");
                        if (languageType) {
                            $(this).find("code").addClass("language-"+languageType);
                        }else{
                            $(this).find("code").addClass("language-jsx");
                        }
                    });
                    Prism.highlightAll();
                },0)

            })
        },
        auditTabHandle(ind){
            this.auditTabInd = ind;
        },
        enterLearn(){
            if(!this.cangodetail){
                this.$notify({title: this.$t('Prompt'), message: "当前课程不在有效学习时间范围内", type: 'warning', duration:2000});
                return  false ;//不允许学习
            }else{
                if(isMobile()){
                    this.$message({
                        message:this.$t('Mobile terminal is not supported, please go to PC terminal operation!'),
                        type:'warning'
                    })
                    return
                }
                this.$router.push({path:"/courseTask/"+this.spaceid+"/"+this.reportInfo.subid+"/"+this.sccid+'/0'})
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/homepage/dialogInformation.scss';
</style>



// WEBPACK FOOTER //
// src/page/Public/ClassManagement/Teachers/dialog/dialogTaskReport.vue